import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import './ApprovalHistory.styles.scss'


const handleDateFormat = (value) => {
    var d = new Date(value);
    let date_ = d.toDateString().split(" ");
    return (
        date_[2] +
        `${
        date_[2] == 1       // eslint-disable-line
            ? "st"
            : date_[2] == 2         // eslint-disable-line
                ? "nd"
                : date_[2] == 3         // eslint-disable-line
                    ? "rd"
                    : "th"
        }` +
        ` ` +
        date_[1] +
        ` ` +
        date_[3]
    );
}

const handleTimeFormat = (value) => {
    var d = new Date(value);
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
}

const ApprovalHistory = (props) => {
    return (
        <div>
            <Modal
                className='main-pop-up-history'
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={props.isOpen}
                onClose={props.handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={props.isOpen}>
                    <div className='pop-up-container-history' >
                        <div className='pop-up-heading-container-history'>
                            <h2 id="transition-modal-title" className='pop-up-heading'>Approval History</h2>
                            <h3 style={{ marginTop: '0px', cursor: 'pointer' }} onClick={props.handleHistorySideBar}>X</h3>
                        </div>
                        <div className='pop-up-data'>

                           
                            <ul id="timeline">
                                {props?.approvalHistory ? props?.approvalHistory.map((item, ind) => (
                                    <li className="work" key={ind}>
                                        <div className="relative">
                                            <span className="circle-ci" />
                                            <span className='dialogue-box-pointer'></span>
                                        </div>
                                        <div className="content">
                                            <div className='comment-dialogue'>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>{handleDateFormat(item.DateCreated)}</span>
                                                    <span className={item.action_status === 'submit' ? 'Submit' : item.action_status === 'approve' ? 'Approve' :
                                                        item.action_status === 'reject' ? 'Reject' : item.action_status === 'sendback' ? 'SendBack' :
                                                        item.action_status === 'extend' ? 'Extended' : null}>{item.status}</span>
                                                </div>
                                                <span style={{ marginBottom: '12px' }}>{item.submitted_by}</span>
                                                <span><i>{item.comment}</i></span>
                                                <span style={{ marginTop: 'auto', fontSize: '12px', textAlign: 'right' }}>{handleTimeFormat(item.DateCreated)}</span>
                                            </div>
                                        </div>
                                    </li>
                                ))
                                    :
                                    null
                                    }
                            </ul>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default (ApprovalHistory);